import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function SelectCreateAula() {
  const location = useLocation();
  const navigate = useNavigate();
  const { aluno } = location.state || {};

  function handleNavigate(tipo) {
    if (tipo === 'manual') {
      navigate('/criarAulaManual', { state: { aluno } });
    } else {
      navigate('/criarAula', { state: { aluno } });
    }
  }

  const cardBase =
    "bg-white rounded-2xl p-6 shadow-sm border border-gray-200 " +
    "flex flex-col items-center gap-3 text-center " +
    "hover:shadow-md hover:border-primary/40 hover:scale-[1.02] " +
    "active:scale-[0.97] transition-all duration-200 cursor-pointer";

  const badge =
    "text-[10px] px-2 py-[2px] rounded-full font-semibold uppercase tracking-wide";

  return (
    <div className="flex flex-col justify-center items-center w-full h-[85vh] gap-8 px-4">
      {/* Header */}
      <div className="flex flex-col gap-1 text-center">
        <h1 className="text-2xl font-semibold">Como você quer agendar a aula?</h1>
        <p className="text-sm text-gray-500">
          Fluxo guiado evita erro e é mais rápido na prática
        </p>
      </div>

      {/* Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full max-w-xl">
        
        {/* Wizard */}
        <div
          className={`${cardBase} border-primary/40 bg-primary/5`}
          onClick={() => handleNavigate('wizard')}
        >
          <span className="material-icons text-primary text-3xl">timeline</span>
          <div className="flex items-center gap-2 flex-col">
            <p className="font-medium">Passo a passo</p>
            <span className={`${badge} bg-primary/20 text-primary`}>
              Recomendado
            </span>
          </div>
          <p className="text-sm text-gray-500">
            Você escolhe uma coisa por vez. Zero chance de errar a ordem.
          </p>
        </div>

        {/* Manual */}
        <div
          className={cardBase}
          onClick={() => handleNavigate('manual')}
        >
          <span className="material-icons text-gray-600 text-3xl">app_registration</span>
          <p className="font-medium">Modo manual</p>
          <p className="text-sm text-gray-500">
            Tudo numa tela só. Mais rápido se você já souber o que quer.
          </p>
        </div>
      </div>
    </div>
  );
}
